<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Agency Settings</h4>
        </div>
    </div>
<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<div class="row" 
     *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  && global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col ">
            <div class="card-body  widget-body pb-0 pt-2 mb-3">
            </div>
            <div widget class="card border-0 box-shadow">
                
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <div class="d-flex row mt-2 pl-3">
                            <div class="col-lg-10">
                                
                                    <label class="usrLbl mb-3"><b>CCX Support</b></label>
                                    <div class="row ms-1 mb-3">
                                        <div class="col-8">
                                            <input type="checkbox" [(ngModel)]="setting.isCCXWidget" (change)="SaveOrUpdate()"
                                                >&nbsp;
                                            <label for="Client">Turn On widget</label>
                                        </div>
                                    </div>
                                    <button class="btn btn-sm ms-3 me-2" (click)="generateApi()" *ngIf="setting.isCCXWidget " [disabled]="!IsWidgetKeyExpired" >Generate API Key </button>
                                    <button class="btn btn-sm ms-2 " style="color: white;background-color: red;" (click)="revokeApi()" *ngIf="setting.isCCXWidget" [disabled]=" apiKey == undefined || apiKey == '' || apiKey == '00000000-0000-0000-0000-000000000000' || apiKey == null "
                                    >Revoke API Key </button>                                                                                          
                            </div>
                            <div class="row ms-1 mt-3" *ngIf="setting.isCCXWidget" > 
                                <div>
                                    <div class="col-4 d-inline-flex">
                                      <input type="text" class="form-control" placeholder="Your API Key" aria-label="Your Api Key" [(ngModel)]="apiKey" [disabled]="true" aria-describedby="button-addon2">
                                      <button class="btn btn-sm" type="button" id="button-addon2" (click)="copyToClipboard()" [disabled]=" apiKey == undefined || apiKey == '' || apiKey == '00000000-0000-0000-0000-000000000000' || apiKey == null ">{{btn1text}}</button>
                                    </div>
                                </div>
                            </div> 
                            <!-- <div class="row ms-1 mt-3" *ngIf="setting.isCCXWidget" > 
                                <label >Expire's on {{setting?.widgetAccessKeyBO?.expireDate}} </label>
                            </div> -->
                    
                    </div>
                    
                      
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-1"
     *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined  && global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col mt-4">
            <div class="card-body  widget-body pb-0 pt-2 mb-3">
            </div>
            <div widget class="card border-0 box-shadow">
                
                <div class="card-body  widget-body pb-0 pt-2 mb-4">
                    <button class="btn btn-primary-2" style="float:right;width: 70px;" (click)="SaveIvrConfiguration()" [disabled]="SaveIvr.outBoundCallFlowId == null || SaveIvr.outBoundCallFlowId == '' ||SaveIvr.outBoundCallFlowId == undefined ||SaveIvr.outBoundCallFlowId == '00000000-0000-0000-0000-000000000000' || ccxAccessKey =='00000000-0000-0000-0000-000000000000' ||  !SaveIvr.businessStartTime || !SaveIvr.businessEndTime || !SaveIvr.outBoundCallRetryDelay || !SaveIvr.outBoundMaxCallAttempts " >Save </button>
                    <div class="d-flex row mt-2 pl-3">
                        <div class="col-lg-10">
                          <label class="usrLbl mb-3"><b>Event Outbound Call Configuration</b></label>
                     
                          <!-- CCX Access Key -->
                          <div class="row ms-1 mt-3">
                            <div class="col-6 d-inline-flex">
                              <label class="me-1 label-bold w-50">CCX Access Key</label>
                              <input type="text" [(ngModel)]="ccxAccessKey" class="form-control w-100" />
                            </div>
                          </div>
                      
                          <!-- Show below inputs only if GUID is valid -->
                          <div *ngIf="isValidGuid(ccxAccessKey)">

                            <div class="row ms-1 mt-3">
                                <div class="col-6 d-inline-flex">
                                  <label class="me-2 label-bold w-50">Call Flow ID<sup class="super-script">*</sup></label>
                                  <input type="text" [(ngModel)]="SaveIvr.outBoundCallFlowId" class="form-control w-100" />
                                </div>
                              </div>
                                <div class="row ms-1 mt-3">
                                <div class="col-6 d-inline-flex">
                                  <label class="me-2 label-bold w-50">SMS Flow ID</label>
                                  <input type="text" [(ngModel)]="SaveIvr.smsFlowId" class="form-control w-100" />
                                </div>
                              </div>

                            <div class="row ms-1 mt-3">
                              <div class="col-4 d-inline-flex">
                                <label class="me-2 label-bold w-50">Business Start Time<sup class="super-script">*</sup></label>
                                <input type="time" [(ngModel)]="SaveIvr.businessStartTime" class="form-control w-50"  (change)="validateTime()" />
                              </div>
                            </div>
                      
                            <div class="row ms-1 mt-3">
                              <div class="col-4 d-inline-flex">
                                <label class="me-2 label-bold w-50">Business End Time<sup class="super-script">*</sup></label>
                                <input type="time" [(ngModel)]="SaveIvr.businessEndTime" class="form-control w-50"  (change)="validateTime()" />
                              </div>
                            </div>
                                                                   
                            <div class="row ms-1 mt-3">
                              <div class="col-4 d-inline-flex">
                                <label class="me-2 label-bold w-50">Call Retry Delay (min)<sup class="super-script">*</sup></label>
                                <input type="number" [(ngModel)]="SaveIvr.outBoundCallRetryDelay" class="form-control w-50"   (input)="validateRetryDelay($event)" (keypress)="keyPressDelay($event)" min="30" max="1140" />
                              </div>
                            </div>
                      
                            <div class="row ms-1 mt-3">
                              <div class="col-4 d-inline-flex">
                                <label class="me-2 label-bold w-50">Max Call Attempts<sup class="super-script">*</sup></label>
                                <input type="number" [(ngModel)]="SaveIvr.outBoundMaxCallAttempts" class="form-control w-50"   (input)="validateMaxAttempts($event)" (keypress)="keyPress($event)" min="1" max="5"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                </div>
            </div>
        </div>
    </div>
</div>